import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { isMobile } from 'mobile-device-detect';
import { connect } from 'react-redux';
import { Spinner, Col, Input, Row } from 'reactstrap';
import './style.scss';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import axios from 'axios';
import ProductSlider from 'react-slick';
import Rating from 'react-rating';
import Hashids from 'hashids/cjs';
import { config } from '../../settings';
import Product from '../../models/Product';
import cartActions from '../../utils/cart';
import Icon from '../../components/Icon';
import PageWrap from '../../components/page-wrap';
import { ShopStore } from '../../stores';
import exitIntent from '../../components/ExitIntent';
import { language, messages } from '../../utils/localeUtils';
import * as Sentry from '@sentry/react';
import { Transducer } from '../../utils/transducer';

const hashids = new Hashids('', 12);

// FIXME Move these to a component to be reused
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
    >
      <Icon name="chevron-right" />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      onClick={onClick}
    >
      <Icon name="chevron-left" />
    </div>
  );
}

const sliderSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 8,
  slidesToScroll: 2,
  initialSlide: 0,
  nextArrow: <SampleNextArrow />,
  prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 6,
        slidesToScroll: 3,
      },
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 4,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
      },
    },
  ],
};

function Cart(props) {
  const { auth } = props; // FIXME We can start using ShopStore to get the cart and other details - phase out using Redux for this

  const cart = ShopStore.useState((s) => s.cart);
  const user = auth && auth.user ? auth.user : {};

  const [lineItems, setLineItems] = useState([]);
  const [discountCode, setDiscountCode] = useState(null);
  const [discountError, setDiscountError] = useState(null);
  const [tryListProducts, setTryListProducts] = useState([]);
  const [favoriteProducts, setFavoriteProducts] = useState([]);
  const [applyingDiscount, setApplyingDiscount] = useState(false);

  const [loading, setLoading] = useState(false);

  const darkMode = Transducer.getPreference('dark_mode') === 'true';

  console.log('cart:');
  console.log(cart);

  useEffect(() => {
    const removeExitIntent = exitIntent({
      maxDisplays: 99999,
      eventThrottle: 100,
      triggerAfterInactiveSecondsDesktop: 8000, // FIXME Should this work this way? Setting it high for now so it doesn't trigger
      triggerAfterInactiveSecondsMobile: 8000,
      triggerAgainAfterSeconds: 300,
      onExitIntent: async () => {
        console.log('Saving cart...');
        console.log(cart);
        // alert('Do you need help with your order?');
        if (cart.id && cart.token) {
          if (window.analytics) {
            window.analytics.track('Abandoned Carts', { cart_id: cart.id, cart_token: cart.token });
          }
        }
        // FIXME This isn't working to change the status in our db - above analytics seems to be working, tho
        await cartActions.update(cart, true);
        // INFO Seems like it won't wait for the await so the inner code wouldn't run in the "then" callback
        // await axios.put(`${config.shopEndPoint}/carts/${updatedCart.id}/abandoned`);
      },
    });
    return () => removeExitIntent();
  }, []);

  useEffect(() => {
    if (isMobile) {
      // FIXME We should have a config list of blacklisted routes for this bar - hide it in the component itself based on the route
      if (document.getElementById('mobile-search-bar')) {
        document.getElementById('mobile-search-bar').style.display = 'none';
      }
    }

    // console.log('Shop State:');
    // console.log(shop);
    console.log('Cart:');
    console.log(cart);

    if (cart.items && cart.items.length > 0) {
      setLineItems(cart.items);
    } else if (user && user.id) {
      setLineItems([]);
      console.log('Getting try list products for user...');
      // FIXME Use the /users/${user.id}shop/all selector?
      axios.get(`${config.shopEndPoint}/users/${user.id}/all`).then((response) => {
        console.log('Got try list items for user:');
        const categories = response.data;
        console.log(categories);
        categories.forEach((category) => {
          console.log(category);
          if (category.title === 'Saved From Your Try List') {
            setTryListProducts(category.products);
          } else if (category.title === 'Just For You') {
            // FIXME This is technically recommended products, not favorites. I'd like to see both and one that uses
            //  what's in their cart to ML some recommendations in that scenario - this currently only gives suggestions
            //  when their cart is empty
            setFavoriteProducts(category.products);
          }
        });
      }).catch((err) => {
        console.log(err);
        Sentry.captureException(err);
      });
    }

    // TODO Scroll to top if first time visiting the page

    return () => {
      if (isMobile) {
        // FIXME Sometimes this fires after the componentWillMount from another component and shows it when it shouldn't
        if (document.getElementById('mobile-search-bar')) {
          document.getElementById('mobile-search-bar').style.display = 'flex';
        }
      }
    };
  }, [cart]);

  const calculateSubtotal = () => {
    let savings = 0;
    if (!cart.subtotal_price) {
      let total = 0;
      cart.items.forEach((item) => {
        if (item.total_price) {
          total += item.total_price;
        } else {
          total += (item.price * item.quantity);
        }
      });
      ShopStore.update((s) => {
        s.cart.subtotal_price = total;
      });
    }
    if (cart.discounts && Array.isArray(cart.discounts) && cart.discounts.length > 0) {
      cart.discounts.forEach((discount) => {
        if (discount.type === 'fixed') {
          savings += discount.amount;
        } else if (discount.type === 'percentage') {
          savings += (cart.subtotal_price * (discount.amount / 100));
        }
      });
    }
    console.log('Total savings:');
    console.log(savings);
    return `$${(cart.subtotal_price - savings).toFixed(2)}`;
  };

  const renderLineItem = (item) => {
    if (!item.product) {
      cartActions.removeProduct(item.unique_id);
      return null;
    }
    return (
      <li className="snipcart-item-line">
        <div className="snipcart-item-line__product">
          <div className="snipcart-item-line__header">
            <figure className="snipcart-item-line__media snipcart-item-line__media--small">
              {/* TODO I Think this should be square cropped if we actually have a product image, circle if not? */}
              <Avatar src={Product.getImage(item.product)} style={{ height: 60, width: 60, marginRight: 10 }} />
            </figure>
            <p className="snipcart-item-line__title snipcart__font--xlarge snipcart__font--secondary snipcart__font--black">
              <Link to={`/products/${item.product.hash_id}`}>
                <div>{Product.title(item.product)}</div>
                <div style={{ fontWeight: 500, fontSize: 14 }}>{Product.packageTitle(item.product)}</div>
              </Link>
            </p>
            <div className="snipcart-item-line__actions">
              <button
                className="snipcart__button--icon"
                onClick={async () => {
                  cartActions.removeProduct(item.unique_id).then(() => {
                    // Do anything?
                  }).catch((error) => {
                    console.log(error);
                    Sentry.captureException(error);
                  });
                }}
              >
                <svg
                  viewBox="0 0 64 64"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  alt="Remove item"
                  title="Remove item"
                  className="snipcart__icon--red snipcart__icon"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M22 4v6.47H12v3.236h40V10.47H42V4H22zm3.333 6.47V7.235H38.67v3.235H25.333zm20.001 9.707h3.333V59H15.334V20.177h3.333v35.588h26.667V20.177zm-15 29.116V23.412h3.334v25.881h-3.334z"
                    fill="#313749"
                  >
                  </path>
                </svg>
              </button>
            </div>
          </div>
          <div className="snipcart-item-line__content">
            <div className="snipcart-item-line__body">
              <div className="snipcart-item-line__info" />
              <div className="snipcart-item-line__variants">
                <div className="snipcart-item-custom-fields" />
                <div className="snipcart-item-quantity snipcart-item-line__quantity">
                  <label
                    className="snipcart-item-quantity__label snipcart__font--tiny"
                  >
                    {'Quantity'}
                  </label>
                  <div className="snipcart-item-quantity__quantity-price-container">
                    <div className="snipcart-item-quantity__quantity snipcart__font--std">
                      <button
                        className="snipcart__button--icon snipcart__button--no-border snipcart-item-quantity__button"
                        onClick={async () => {
                          console.log('Updating item:');
                          console.log(item);
                          console.log(item.quantity - 1);
                          cartActions.updateProduct({
                            ...item,
                            quantity: item.quantity - 1,
                          }).then().catch((error) => {
                            console.log(error);
                            Sentry.captureException(error);
                          });
                        }}
                      >
                        <svg
                          viewBox="0 0 64 64"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          alt="Decrement quantity"
                          title="Decrement quantity"
                          className="snipcart__icon"
                        >
                          <path d="M48 31H16v2.462h32V31z" fill="#313749" />
                        </svg>
                      </button>
                      <span className="snipcart__font--secondary snipcart__font--regular">
                        {item.quantity}
                      </span>
                      <button
                        className="snipcart__button--icon snipcart__button--no-border snipcart-item-quantity__button"
                        onClick={async () => {
                          console.log('Updating item:');
                          console.log(item);
                          console.log(item.quantity + 1);
                          cartActions.updateProduct({
                            ...item,
                            quantity: item.quantity + 1,
                          }).then().catch((error) => {
                            console.log(error);
                            Sentry.captureException(error);
                          });
                        }}
                      >
                        <svg
                          viewBox="0 0 64 64"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          alt="Increment quantity"
                          title="Increment quantity"
                          className="snipcart__icon"
                        >
                          <path
                            d="M33.23 30.77H48v2.46H33.23V48h-2.46V33.23H16v-2.46h14.77V16h2.46v14.77z"
                            fill="#313749"
                          >
                          </path>
                        </svg>
                      </button>
                    </div>
                    <div
                      className="snipcart-item-quantity__total-price snipcart__font--bold snipcart__font--secondary"
                      style={{ fontSize: 15 }}
                    >
                      {/* FIXME Instead of rendering '0', show a skeleton view until the price loads */}
                      {/* TODO This used to calculate the total_price - update the server to do so? */}
                      {`$${item.price ? (item.quantity * item.price).toFixed(2) : 0}`}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    );
  };

  // TODO Handle loading skeleton view

  if (!lineItems || lineItems.length === 0) {
    return (
      <PageWrap>
        <div style={{ marginTop: 30, textAlign: 'center' }}>
          <div>
            <div style={{ marginTop: 24 }}>
              {'There are no products in your cart.'}
            </div>
            <Button
              variant="contained"
              color="primary"
              style={{ marginTop: 20 }}
              onClick={() => props.history.push('/shop/all')}
            >
              {'Shop Now'}
            </Button>
            {(tryListProducts && tryListProducts.length > 0) ? (
              <div style={{ marginTop: 20 }}>
                <span style={{ fontWeight: 600, margin: 16 }}>Saved from your Try List</span>
                <div style={{ margin: 16 }}>
                  <ProductSlider {...sliderSettings}>
                    {
                      tryListProducts.map((product, i) => {
                        const externalProducts = false; // FIXME If not Sigaro Smoke Shop, then true - just redirect to website

                        let price = product.msrp;
                        if (product.sale_price) {
                          price = product.sale_price;
                        }

                        let formattedPrice = price;
                        if (typeof price === 'number') {
                          formattedPrice = `$${price.toFixed(2)}`;
                        } else if (typeof price === 'string' && price.indexOf('$') === -1) {
                          formattedPrice = `$${parseFloat(price).toFixed(2)}`;
                        }

                        return (
                          <div key={`order-try-list-${i}`}>
                            <Link to={`/products/${hashids.encode(product.id)}`}>
                              <div
                                style={{
                                  textAlign: 'center',
                                  padding: 5,
                                }}
                              >
                                <img src={Product.getImage(product)} alt={Product.title(product)} style={{ maxWidth: '100%' }} />
                                <div style={{ fontSize: 10 }}>{Product.title(product)}</div>
                                <div>{Product.packageTitle(product)}</div>
                                <Rating
                                  initialRating={product.avg_rating / 20}
                                  emptySymbol="far fa-star"
                                  fullSymbol="fas fa-star"
                                  fractions={2}
                                  readonly
                                  style={{ color: 'rgb(214, 194, 144)' }}
                                />
                                <div>{`${product.total_ratings || 0} ratings`}</div>
                                {formattedPrice && (
                                  <button
                                    className={`btn ${externalProducts ? 'btn-outline-success' : 'btn-success'} boxpressd-add-item`}
                                    style={{ fontSize: 14 }}
                                    data-item-id={hashids.encode(product.id)}
                                    data-item-price={price}
                                    data-item-url={`${config.shopEndPoint}/products/${hashids.encode(product.id)}/verify`}
                                    data-item-description={product.description}
                                    data-item-image={Product.getImage(product)}
                                    data-item-name={Product.title(product)}
                                  >
                                    {formattedPrice}
                                  </button>
                                )}
                              </div>
                            </Link>
                          </div>
                        );
                      })
                    }
                  </ProductSlider>
                </div>
              </div>
            ) : null}
            {(favoriteProducts && favoriteProducts.length > 0) ? (
              <div style={{ marginTop: 20 }}>
                <span style={{ fontWeight: 600, margin: 16 }}>Just For You</span>
                <div style={{ margin: 16 }}>
                  <ProductSlider {...sliderSettings}>
                    {
                      favoriteProducts.map((product, i) => {
                        const externalProducts = false; // FIXME If not Sigaro Smoke Shop, then true - just redirect to website

                        let price = product.msrp;
                        if (product.sale_price) {
                          price = product.sale_price;
                        }

                        let formattedPrice = price;
                        if (typeof price === 'number') {
                          formattedPrice = `$${price.toFixed(2)}`;
                        } else if (typeof price === 'string' && price.indexOf('$') === -1) {
                          formattedPrice = `$${parseFloat(price).toFixed(2)}`;
                        }

                        return (
                          <div key={`order-try-list-${i}`}>
                            <Link to={`/products/${hashids.encode(product.id)}`}>
                              <div
                                style={{
                                  textAlign: 'center',
                                  padding: 5,
                                }}
                              >
                                <img src={Product.getImage(product)} alt={Product.title(product)} style={{ maxWidth: '100%' }} />
                                <div style={{ fontSize: 10 }}>{Product.title(product)}</div>
                                <div>{Product.packageTitle(product)}</div>
                                <Rating
                                  initialRating={product.avg_rating / 20}
                                  emptySymbol="far fa-star"
                                  fullSymbol="fas fa-star"
                                  fractions={2}
                                  readonly
                                  style={{ color: 'rgb(214, 194, 144)' }}
                                />
                                <div>{`${product.total_ratings || 0} ratings`}</div>
                                {formattedPrice && (
                                  <button
                                    className={`btn ${externalProducts ? 'btn-outline-success' : 'btn-success'} boxpressd-add-item`}
                                    style={{ fontSize: 14 }}
                                    data-item-id={hashids.encode(product.id)}
                                    data-item-price={price}
                                    data-item-url={`${config.shopEndPoint}/products/${hashids.encode(product.id)}/verify`}
                                    data-item-description={product.description}
                                    data-item-image={Product.getImage(product)}
                                    data-item-name={Product.title(product)}
                                  >
                                    {formattedPrice}
                                  </button>
                                )}
                              </div>
                            </Link>
                          </div>
                        );
                      })
                    }
                  </ProductSlider>
                </div>
              </div>
            ) : null}
          </div>
        </div>
      </PageWrap>
    );
  }

  return (
    <PageWrap>
      <div style={{ margin: '60px auto', marginTop: 30, maxWidth: 840 }}>
        <section className="snipcart-cart__content">
          {/* FIXME Each shop should have it's own "block" of cart items as separate shipments (similar to Amazon breaking up shipments) */}
          <ul className="snipcart-item-list snipcart-item-list--no-shadow">
            <div className="boxpressd-cart__line-items-header"><h3>Ships from {lineItems[0].venue ? lineItems[0].venue.name : 'Sigaro Smoke Shop'}</h3></div>
            {lineItems.map((item) => renderLineItem(item))}
            <div className="boxpressd-cart__line-items-footer">
              Sold by {lineItems[0].venue ? lineItems[0].venue.name : 'Sigaro Smoke Shop'}, a licensed cigar reseller.
            </div>
          </ul>
          <div className="snipcart-cart__footer">
            <div className="snipcart-cart__footer-col cart__footer-discount-box snipcart-cart__actions">
              <div className="snipcart-discount-box snipcart__font--secondary snipcart-cart__discount-box">
                {discountError && <span style={{ fontSize: 12, color: '#ef5164' }}>{discountError}</span>}
                <div style={{ display: 'flex' }}>
                  <Input
                    id="discount"
                    type="text"
                    name="discount"
                    placeholder="Enter Discount Code"
                    value={discountCode}
                    onChange={(event) => setDiscountCode(event.target.value)}
                    className="snipcart-input__input snipcart__font--secondary snipcart__font--bold"
                    style={{ textTransform: 'uppercase' }}
                  />
                  <button
                    type="button"
                    disabled={applyingDiscount}
                    className="snipcart-inline-discount-btn"
                    onClick={(e) => {
                      e.preventDefault();
                      console.log('Clicked');
                      setApplyingDiscount(true);
                      cartActions.applyDiscount(discountCode).then((response) => {
                        setApplyingDiscount(false);
                        setDiscountError(null);
                        setDiscountCode('');
                        console.log(response);
                      }).catch((err) => {
                        setApplyingDiscount(false);
                        console.log('Unable to add discount:');
                        console.log(err);
                        Sentry.captureException(err);
                        // FIXME Should there be some sort of format like this coming from the server?
                        if (err.fields && err.fields.code && err.fields.code.length > 0) {
                          console.log(err.fields.code[0]);
                          if (err.fields.code[0].message === 'promo_code_is_expired') {
                            setDiscountError('Discount code is expired');
                          } else {
                            setDiscountError('Invalid discount code');
                          }
                        } else {
                          setDiscountError(err);
                        }
                      });
                    }}
                  >
                    {applyingDiscount && <Spinner color={darkMode ? 'light' : 'dark'} />}
                    {applyingDiscount ? '' : 'Add'}
                  </button>
                </div>
              </div>
            </div>
            <hr />
            <div className="snipcart-cart__footer-col">
              <div className="snipcart-cart-summary-fees snipcart-cart-summary-fees--reverse">
                <div className="snipcart-cart-summary-fees__notice snipcart__font--regular">
                  {'Shipping and taxes will be calculated at checkout.'}
                </div>
                <div className="snipcart-cart-summary-fees">
                  <div
                    className="snipcart-cart-summary-fees__item snipcart-cart-summary-fees__total snipcart__font--bold snipcart__font--secondary"
                  >
                    <span
                      className="snipcart-cart-summary-fees__title snipcart-cart-summary-fees__title--highlight snipcart__font--large"
                      style={{ fontWeight: 600 }}
                    >
                      {'Subtotal'}
                    </span>
                    <span
                      className="snipcart-cart-summary-fees__amount snipcart-cart-summary-fees__amount--highlight snipcart__font--large"
                      style={{ fontWeight: 600 }}
                    >
                      {calculateSubtotal()}
                    </span>
                  </div>
                </div>
                {cart.discounts && Array.isArray(cart.discounts) && cart.discounts.map((discount) => (
                  <div className="snipcart-cart-summary-fees" style={{ marginBottom: 8 }}>
                    <div
                      className="snipcart-cart-summary-fees__item snipcart-cart-summary-fees__total snipcart__font--bold snipcart__font--secondary"
                    >
                      <span
                        className="snipcart-cart-summary-fees__title snipcart-cart-summary-fees__title--highlight snipcart__font--large"
                      >
                        <Icon name="tag" style={{ marginRight: 6 }} />
                        {`${discount.name}`}
                        <Icon
                          name="trash"
                          style={{ marginLeft: 16, marginTop: -2 }}
                          onClick={() => {
                            console.log('Removing discount code...');
                            cartActions.removeDiscount(discount.name).then((response) => {
                              console.log(response);
                            });
                          }}
                        />
                      </span>
                      <span
                        className="snipcart-cart-summary-fees__amount snipcart-cart-summary-fees__amount--highlight snipcart__font--large"
                      >
                        {discount.type === 'percentage' && `-$${(cart.subtotal_price * (discount.amount / 100)).toFixed(2)}`}
                        {discount.type === 'fixed' && `-$${discount.amount.toFixed(2)}`}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
              <footer>
                <button
                  type="button"
                  className="snipcart-cart-button snipcart__font--bold snipcart__font--secondary snipcart-cart-button--large snipcart-cart-button--highlight snipcart-cart-button--spaced snipcart__font--large"
                  // onClick={() => {
                  //   ModalDialog.show({
                  //     title: 'Checkout Currently Unavailable',
                  //     message: "We're working hard to finish our inventory and should have this feature available very shortly. Thank you for understanding!",
                  //     buttons: [{
                  //       label: 'Dismiss',
                  //       onClick: () => {
                  //         ModalDialog.close();
                  //       },
                  //     }],
                  //   });
                  // }}
                  onClick={() => {
                    cartActions.update({
                      ...cart,
                      status: 'in_progress',
                    });
                    props.history.push('/checkout');
                  }}
                >
                  <span
                    className="snipcart-cart-button__grid"
                  >
                    <span className="snipcart-cart-button__content">
                      {messages[language]?.checkout || 'Checkout'}
                    </span>
                    {/* <span className="snipcart-cart-button__content">Checkout Disabled</span> */}
                    <span className="snipcart-cart-button__content--right">
                      <svg
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        alt=""
                        title=""
                        className="snipcart__icon"
                      >
                        <path
                          d="M51.364 30.158H6v3.423h45.628l-9.148 9.055L44.868 45 58 32 44.868 19l-2.388 2.364 8.884 8.794z"
                          fill="#313749"
                        >
                        </path>
                      </svg>
                    </span>
                  </span>
                </button>
              </footer>
              <div className="snipcart-cart__featured-payment-methods-container">
                <div className="root">
                  <div className="snipcart-featured-payment-methods">
                    <h3
                      className="snipcart__font--secondary snipcart__font--bold  snipcart-featured-payment-methods__title"
                    >
                      <svg
                        viewBox="0 0 64 64"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        alt=""
                        title=""
                        className="snipcart-featured-payment-methods__title-icon snipcart__icon"
                      >
                        <path
                          d="M16.615 23.765v-4.942C16.615 10.637 23.28 4 31.5 4c8.22 0 14.885 6.637 14.885 14.823v4.942H53V60H10V23.765h6.615zm0 3.294h-3.307v29.647h36.384V27.059H16.615zm13.231 9.882h3.308v9.883h-3.308V36.94zm-9.923-13.176h23.154v-4.942c0-6.367-5.183-11.529-11.577-11.529s-11.577 5.162-11.577 11.53v4.94z"
                          fill={darkMode ? '#d5c196' : '#313749'}
                        />
                      </svg>
                      {`100% ${messages[language]?.secure_checkout || 'Secure Checkout'}`}
                    </h3>
                    <Row className="snipcart-featured-payment-methods__list">
                      <Col className="snipcart-featured-payment-methods__list-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="48"
                          height="36"
                          viewBox="0 0 48 36"
                          className="paymentOptions__paymentIcon--74W1J"
                        >
                          <g fill="none" fillRule="evenodd">
                            <rect width="48" height="36" rx="4" />
                            <path
                              fill="#152883"
                              fillRule="nonzero"
                              d="M21.03 23.833h-3.2l2-12.289h3.2l-2 12.29zm-5.92-12.289l-3.04 8.478-.4-1.789-1.12-5.522s-.16-1.089-1.52-1.089H3.99l-.08.156s1.52.31 3.36 1.4l2.8 10.655h3.36l5.12-12.289h-3.44zm21.84 8.012l1.68-4.59.96 4.59h-2.64zm3.52 4.277h2.96l-2.56-12.289h-2.56c-1.2 0-1.52.934-1.52.934l-4.8 11.355h3.36l.64-1.789h4.08l.4 1.79zm-8.24-9.1l.48-2.644s-1.44-.545-2.88-.545c-1.6 0-5.36.7-5.36 4.045 0 3.189 4.48 3.189 4.48 4.9 0 1.711-4 1.4-5.28.311l-.48 2.8s1.44.7 3.6.7 5.52-1.167 5.52-4.2c0-3.189-4.48-3.5-4.48-4.9 0-1.4 3.04-1.244 4.4-.467z"
                            />
                          </g>
                        </svg>
                      </Col>
                      <Col className="snipcart-featured-payment-methods__list-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="48"
                          height="36"
                          viewBox="0 0 48 36"
                          className="paymentOptions__paymentIcon--74W1J"
                        >
                          <g fill="none" fillRule="evenodd">
                            <rect width="48" height="36" rx="4" />
                            <path fill="#FF5F00" d="M19.253 25.934h9.482V9.776h-9.482z" />
                            <path
                              fill="#F79E1B"
                              d="M39.931 17.855c0 5.675-4.41 10.276-9.85 10.276a9.553 9.553 0 0 1-6.087-2.197c2.291-1.882 3.762-4.8 3.762-8.079 0-3.278-1.47-6.197-3.762-8.079a9.553 9.553 0 0 1 6.088-2.197c5.44 0 9.849 4.6 9.849 10.276"
                            />
                            <path
                              fill="#EB001B"
                              d="M20.232 17.855c0-3.278 1.471-6.197 3.762-8.079a9.553 9.553 0 0 0-6.087-2.197c-5.44 0-9.85 4.6-9.85 10.276 0 5.675 4.41 10.276 9.85 10.276 2.297 0 4.411-.82 6.087-2.197-2.29-1.882-3.762-4.8-3.762-8.079"
                            />
                          </g>
                        </svg>
                      </Col>
                      <Col className="snipcart-featured-payment-methods__list-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="48"
                          height="36"
                          viewBox="0 0 48 36"
                          className="paymentOptions__paymentIcon--74W1J"
                        >
                          <g fill="none" fillRule="evenodd">
                            <rect width="48" height="36" rx="4" />
                            <path
                              fill="#008BB6"
                              fillRule="nonzero"
                              d="M29.592 22.982v-.97s-.062-.777-.807-.777h-1.243v1.747H26.3v-4.917h3.044s1.553-.194 1.553 1.423c0 .841-.683 1.165-.683 1.165s.62.259.62 1.1v1.23h-1.242zm-2.05-2.911h1.305c.373 0 .683-.195.683-.453 0-.26-.31-.453-.683-.453h-1.305v.906zm-6.274 2.911H20.15l-1.305-1.488-1.304 1.488h-4.66V18h4.536l1.428 1.553L20.275 18h3.975s1.553-.194 1.553 1.424c0 1.488-.497 1.94-2.112 1.94h-1.243v1.618h-1.18zm-1.615-2.458l1.553 1.747v-3.43l-1.553 1.683zm-5.529 1.358h2.61l1.242-1.358-1.243-1.36h-2.609v.777h2.547v1.1h-2.547v.841zm8.324-1.811h1.305c.373 0 .683-.195.683-.453 0-.26-.31-.453-.683-.453h-1.305v.906zm15.655 2.911h-2.236v-1.164h1.925s.684.064.684-.389-1.056-.388-1.056-.388-1.74.13-1.74-1.488c0-1.618 1.553-1.553 1.553-1.553h2.423v1.165H37.73s-.683-.13-.683.323c0 .388.932.324.932.324s1.926-.13 1.926 1.359c0 1.617-1.243 1.747-1.678 1.747-.062.064-.124.064-.124.064zm-6.71 0v-4.917h3.915v1.164h-2.61v.777h2.547v1.1h-2.547v.841h2.61v1.1h-3.914v-.065zm11.059 0h-2.237v-1.164h1.926s.683.064.683-.389-1.056-.388-1.056-.388-1.74.13-1.74-1.488c0-1.618 1.554-1.553 1.554-1.553h2.36v1.165h-1.925s-.684-.13-.684.323c0 .388.932.324.932.324s1.926-.13 1.926 1.359c0 1.617-1.243 1.747-1.677 1.747 0 .064-.062.064-.062.064zm-17.394-5.306v-.97s-.063-.777-.808-.777h-1.242v1.747h-1.243V12.76h3.044s1.553-.194 1.553 1.423c0 .842-.683 1.165-.683 1.165s.621.259.621 1.1v1.23h-1.242zm-2.05-2.911h1.304c.373 0 .683-.194.683-.453 0-.26-.31-.453-.683-.453h-1.304v.906zm16.772 2.911l-1.988-3.3v3.3H35.37l-.435-1.035h-2.299l-.434 1.035h-1.926s-1.678-.258-1.678-2.329c0-2.718 1.926-2.653 1.988-2.653l1.553.065v1.035h-1.242s-.808 0-.932 1.1v.324c0 1.682 1.429 1.164 1.491 1.164l1.553-3.688h1.74l1.863 4.465v-4.465h1.74l1.925 3.235v-3.235h1.243v4.982h-1.74zm-6.585-2.329h1.243l-.621-1.488-.622 1.488zm-18.077 2.33v-3.43l-1.615 3.43h-.994l-1.553-3.43v3.43H8.471l-.435-1.036H5.738l-.435 1.035H3.936l2.05-4.917h1.74l1.926 4.53v-4.53h1.987l1.367 3.106 1.367-3.106h1.988v4.917h-1.243zm-8.821-2.265h1.242l-.62-1.488-.622 1.488zm10.933 2.264V12.76h3.914v1.165h-2.61v.776h2.548v1.035h-2.547v.841h2.609v1.1H17.23zm9.691 0v-4.982h1.243v4.982H26.92z"
                            />
                          </g>
                        </svg>
                      </Col>
                      <Col className="snipcart-featured-payment-methods__list-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="48"
                          height="36"
                          viewBox="0 0 48 36"
                          className="paymentOptions__paymentIcon--74W1J"
                        >
                          <g fill="none" fillRule="evenodd">
                            <rect width="48" height="36" rx="4" />
                            <path
                              fill={darkMode ? '#AFAFAF' : '#201D1C'}
                              fillRule="nonzero"
                              d="M7.68 19.607c.436-.386.7-1.003.7-1.62 0-.616-.264-1.215-.7-1.601-.418-.375-.913-.52-1.729-.52h-.339v4.252h.339c.816 0 1.332-.156 1.728-.511zm-1.476-4.83c2.048 0 3.476 1.321 3.476 3.219 0 .946-.437 1.861-1.175 2.468-.622.512-1.33.742-2.31.742H4.35v-6.43h1.854zm4.057 6.43v-6.43h1.263v6.43h-1.263zm4.352-3.963c1.436.522 1.862.984 1.862 2.006 0 1.244-.92 2.11-2.233 2.11-.961 0-1.66-.375-2.242-1.223l.816-.78c.29.558.776.857 1.378.857.564 0 .981-.386.981-.907 0-.27-.126-.501-.379-.665-.127-.078-.378-.193-.873-.366-1.186-.424-1.593-.878-1.593-1.763 0-1.053.874-1.843 2.02-1.843.71 0 1.36.242 1.902.713l-.66.86c-.33-.367-.64-.521-1.019-.521-.544 0-.94.307-.94.712 0 .348.222.531.98.81zm2.26.752c0-1.87 1.535-3.365 3.448-3.365.544 0 1 .116 1.554.395v1.476c-.525-.51-.981-.724-1.584-.724-1.184 0-2.116.974-2.116 2.209 0 1.302.903 2.217 2.175 2.217.573 0 1.02-.202 1.525-.704v1.476c-.574.269-1.04.375-1.584.375-1.923 0-3.417-1.465-3.417-3.355zm15.017 1.1l1.749-4.32h1.369l-2.798 6.595h-.68l-2.747-6.594h1.38l1.727 4.318zm3.69 2.11v-6.43h3.581v1.09h-2.32v1.427h2.234v1.09h-2.234v1.735h2.32v1.088h-3.582zm6.048-3.47c.807 0 1.234-.347 1.234-.994 0-.625-.427-.953-1.214-.953h-.389v1.948h.369zm2.534-1.061c0 .984-.524 1.63-1.475 1.823l2.038 2.708h-1.553l-1.748-2.583h-.165v2.583h-1.262v-6.43h1.873c1.457 0 2.292.695 2.292 1.899z"
                            />
                            <path
                              fill="#F59314"
                              d="M22.3 17.899v.002a3.4 3.4 0 0 0 6.8 0v-.002a3.4 3.4 0 0 0-6.8 0"
                            />
                          </g>
                        </svg>
                      </Col>
                      <Col className="snipcart-featured-payment-methods__list-item">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="48"
                          height="36"
                          viewBox="0 0 48 36"
                          className="paymentOptions__paymentIcon--74W1J"
                        >
                          <g fill="none" fillRule="evenodd">
                            <rect width="48" height="36" rx="4" />
                            <path
                              fill="#218EC2"
                              d="M31.302 15.998c-.17 1.149-1.021 1.149-1.845 1.149h-.469L29.317 15a.262.262 0 0 1 .256-.225h.215c.56 0 1.09 0 1.363.33.163.196.212.488.15.892zM30.943 13h-3.106a.436.436 0 0 0-.426.375l-1.256 8.208a.264.264 0 0 0 .256.308h1.594a.305.305 0 0 0 .298-.262l.356-2.327a.436.436 0 0 1 .426-.376h.983c2.046 0 3.226-1.02 3.535-3.042.14-.885.006-1.58-.396-2.066-.442-.535-1.225-.818-2.264-.818z"
                            />
                            <path
                              fill="#253666"
                              d="M9.15 15.998c-.17 1.149-1.022 1.149-1.845 1.149h-.469L7.166 15a.261.261 0 0 1 .255-.225h.215c.56 0 1.09 0 1.363.33.163.196.212.488.15.892zM8.79 13H5.685a.436.436 0 0 0-.426.375l-1.256 8.208a.264.264 0 0 0 .256.308h1.483c.212 0 .393-.159.426-.375l.339-2.214a.436.436 0 0 1 .426-.376h.983c2.046 0 3.227-1.02 3.535-3.042.139-.885.006-1.58-.396-2.066C10.613 13.283 9.83 13 8.79 13zM16.002 18.944c-.144.876-.819 1.464-1.679 1.464-.431 0-.777-.143-.999-.414-.22-.268-.302-.65-.233-1.076.134-.868.82-1.475 1.667-1.475.422 0 .765.144.992.417.227.276.317.66.252 1.084zm2.072-2.983h-1.487a.261.261 0 0 0-.256.225l-.065.429-.104-.156c-.322-.481-1.04-.642-1.757-.642-1.643 0-3.046 1.283-3.32 3.083-.142.897.06 1.755.554 2.354.454.55 1.102.78 1.873.78 1.325 0 2.06-.877 2.06-.877l-.067.426a.264.264 0 0 0 .256.308H17.1c.212 0 .393-.159.426-.375l.804-5.247a.264.264 0 0 0-.256-.308z"
                            />
                            <path
                              fill="#218EC2"
                              d="M38.154 18.944c-.144.876-.819 1.464-1.679 1.464-.431 0-.777-.143-.999-.414-.22-.268-.302-.65-.233-1.076.134-.868.82-1.475 1.667-1.475.422 0 .765.144.992.417.227.276.317.66.252 1.084zm2.072-2.983H38.74a.261.261 0 0 0-.256.225l-.065.429-.104-.156c-.322-.481-1.04-.642-1.757-.642-1.643 0-3.046 1.283-3.32 3.083-.142.897.06 1.755.554 2.354.454.55 1.102.78 1.873.78 1.325 0 2.06-.877 2.06-.877l-.067.426a.264.264 0 0 0 .256.308h1.339c.212 0 .393-.159.426-.375l.804-5.247a.264.264 0 0 0-.256-.308z"
                            />
                            <path
                              fill="#253666"
                              d="M25.995 15.96H24.5a.428.428 0 0 0-.357.196l-2.062 3.13-.874-3.008a.434.434 0 0 0-.413-.317h-1.47c-.177 0-.302.18-.244.353l1.646 4.98-1.549 2.25c-.121.177.002.422.212.422h1.493a.428.428 0 0 0 .355-.192l4.971-7.394c.12-.177-.004-.42-.213-.42"
                            />
                            <path
                              fill="#218EC2"
                              d="M41.98 13.225l-1.275 8.358a.264.264 0 0 0 .255.308h1.282c.213 0 .393-.159.427-.375l1.256-8.208A.264.264 0 0 0 43.67 13h-1.435a.261.261 0 0 0-.256.225"
                            />
                          </g>
                        </svg>
                      </Col>
                      <Col className="snipcart-featured-payment-methods__list-item">
                        <a
                          href={`https://verify.authorize.net/anetseal/?pid=3f80660b-7ab1-4aa8-b7ba-1fc3e298f998&rurl=${window.location.hostname}`}
                          onMouseOver={() => { window.status = 'http://www.authorize.net/'; return true; }}
                          onMouseOut={() => { window.status = ''; return true; }}
                          onClick={(e) => {
                            e.preventDefault();
                            window.open(`https://verify.authorize.net/anetseal/?pid=3f80660b-7ab1-4aa8-b7ba-1fc3e298f998&rurl=${window.location.hostname}`, 'AuthorizeNetVerification', 'width=600,height=430,dependent=yes,resizable=yes,scrollbars=yes,menubar=no,toolbar=no,status=no,directories=no,location=yes');
                            return false;
                          }}
                          rel="noopener noreferrer"
                          target="_blank"
                        >
                          <img
                            src="https://verify.authorize.net/anetseal/images/secure90x72.gif"
                            alt="Authorize.Net Merchant - Click to Verify"
                            style={{ height: 36 }}
                          />
                        </a>
                      </Col>
                    </Row>
                  </div>
                  <div style={{ margin: 20, textAlign: 'center' }}>
                    Boxpressd and its affiliates do not sell to anyone under 21 years of age or the minimum legal age in
                    their jurisdiction, whichever is higher. By clicking &quot;Continue&quot; you agree to our <a href="https://boxpressd.com/legal/sale">Terms of Sale</a>.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </PageWrap>
  );
}

Cart.defaultProps = {
  shop: {
    cart: {},
  },
};

function mapStateToProps(state) {
  return {
    auth: state.get('auth').toJS(),
    shop: state.get('shop').toJS(),
  };
}

export default connect(mapStateToProps)(withRouter(Cart));
